import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3806af6a&scoped=true&"
import script from "./index.vue?vue&type=script&lang=ts&"
export * from "./index.vue?vue&type=script&lang=ts&"
import style0 from "../Create/style.scss?vue&type=style&index=0&id=3806af6a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3806af6a",
  null
  
)

export default component.exports